import * as actionTypes from '../actions/actionTypes';

const initialState = {
  currentStep: 'country',
  projectscope: '',
  projectunitscope: '',
  selectedSteps: {
    country: '',
    fwk: '',
    location: '',
    executionType: '',
    mediumTypes: [],
    productSystem: '',
    productSystemItems: []
  },
  sharedSolution: {
    errorOnLoad: false,
    token: '',
    productSolutionItems: [],
    holeForm: '',
    holeDiameter: '',
    holeHeight: '',
    holeWidth: '',
  },
  productSystemFilters: {
    penetrationId: '',
    insulationId: '',
    productgroupId: '',
  }
};



const reducer = (state=initialState, action) => {
  switch (action.type) {

    case actionTypes.SET_WIZARD_SCOPE_PROJECT:
      return {
        ...state,
        projectscope: action.value,
      };

    case actionTypes.SET_WIZARD_SCOPE_PROJECTUNIT:
      return {
        ...state,
        projectunitscope: action.value,
      };

    case actionTypes.RESET_ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION:
      return {
        ...state,
        selectedSteps: {
          country: initialState.selectedSteps.country,
          fwk: initialState.selectedSteps.fwk,
          location: initialState.selectedSteps.location,
          executionType: initialState.selectedSteps.executionType,
          mediumTypes: initialState.selectedSteps.mediumTypes,
          productSystem: initialState.selectedSteps.productSystem,
          productSystemItems: initialState.selectedSteps.productSystemItems,
        },
        sharedSolution: {
          errorOnLoad: false,
          token: initialState.sharedSolution.token,
          productSolutionItems: initialState.sharedSolution.productSolutionItems,
          holeForm: initialState.sharedSolution.holeForm,
          holeDiameter: initialState.sharedSolution.holeDiameter,
          holeHeight: initialState.sharedSolution.holeHeight,
          holeWidth: initialState.sharedSolution.holeWidth,
        },
        currentStep: 'country'
      };

    case actionTypes.ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION:
      return {
        ...state,
        selectedSteps: {
          country: initialState.selectedSteps.country,
          fwk: initialState.selectedSteps.fwk,
          location: initialState.selectedSteps.location,
          executionType: initialState.selectedSteps.executionType,
          mediumTypes: initialState.selectedSteps.mediumTypes,
          productSystem: initialState.selectedSteps.productSystem,
          productSystemItems: initialState.selectedSteps.productSystemItems,
        },
        sharedSolution: {
          errorOnLoad: true,
          token: initialState.sharedSolution.token,
          productSolutionItems: initialState.sharedSolution.productSolutionItems,
          holeForm: initialState.sharedSolution.holeForm,
          holeDiameter: initialState.sharedSolution.holeDiameter,
          holeHeight: initialState.sharedSolution.holeHeight,
          holeWidth: initialState.sharedSolution.holeWidth,
        },
        currentStep: 'country'
      };

    case actionTypes.SET_WIZARD_BY_PRODUCT_SOLUTION:
      return {
        ...state,
        selectedSteps: {
          country: action.country,
          fwk: action.fwk,
          location: action.location,
          executionType: action.executionType,
          mediumTypes: action.mediumTypes,
          productSystem: action.productSystem,
          productSystemItems: action.productSystemItems,
        },
        sharedSolution: {
          errorOnLoad: false,
          token: action.token,
          productSolutionItems: action.productSolutionItems,
          holeForm: action.holeForm,
          holeDiameter: action.holeDiameter,
          holeHeight: action.holeHeight,
          holeWidth: action.holeWidth,
        },
        currentStep: action.nextStep
      };

    case actionTypes.SET_WIZARD_COUNTRY:
      return {
        ...state,
        selectedSteps: {
          country: action.stepValue,
          fwk: '',
          location: '',
          executionType: '',
          mediumTypes: [],
          productSystem: '',
          productSystemItems: [],
        },
        productSystemFilters: initialState.productSystemFilters,
        currentStep: action.nextStep
      };
    case actionTypes.SET_WIZARD_FWK:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: action.stepValue,
          location: '',
          executionType: '',
          mediumTypes: [],
          productSystem: '',
          productSystemItems: [],
        },
        productSystemFilters: initialState.productSystemFilters,
        currentStep: action.nextStep
      };
    case actionTypes.SET_WIZARD_LOCATION:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: action.stepValue,
          executionType: '',
          mediumTypes: [],
          productSystem: '',
          productSystemItems: [],
        },
        productSystemFilters: initialState.productSystemFilters,
        currentStep: action.nextStep
      };
    case actionTypes.SET_WIZARD_EXECUTION_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: action.stepValue,
          mediumTypes: [],
          productSystem: '',
          productSystemItems: [],
        },
        productSystemFilters: initialState.productSystemFilters,
        currentStep: action.nextStep
      };
    case actionTypes.ADD_WIZARD_MEDIUM_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: Array.from(new Set([...state.selectedSteps.mediumTypes, action.stepValue])),
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: state.currentStep
      };
    case actionTypes.SET_WIZARD_MEDIUM_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: [action.stepValue],
          productSystem: '',
          productSystemItems: [],
        },
        productSystemFilters: initialState.productSystemFilters,
        currentStep: state.currentStep
      };

    case actionTypes.REMOVE_WIZARD_MEDIUM_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: state.selectedSteps.mediumTypes.filter(function(value, index, arr){ return value !== action.stepValue;}),
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: state.currentStep
      };

    case actionTypes.SET_WIZARD_PRODUCT_SYSTEM:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: state.selectedSteps.mediumTypes,
          productSystem: action.stepValue,
          productSystemItems: [],
        },
        productSystemFilters: {
          penetrationId: action.selectedPenetration,
          insulationId: action.selectedInsulation,
          productgroupId: action.selectedProductgroup,
        },
        currentStep: action.nextStep
      };

    case actionTypes.ADD_WIZARD_PRODUCT_SYSTEM_ITEM:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: state.selectedSteps.mediumTypes,
          productSystem: state.selectedSteps.productSystem,
          productSystemItems: Array.from(new Set([...state.selectedSteps.productSystemItems, action.value])),
        },
        currentStep: state.currentStep
      };

    case actionTypes.REMOVE_WIZARD_PRODUCT_SYSTEM_ITEM:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: state.selectedSteps.mediumTypes,
          productSystem: state.selectedSteps.productSystem,
          productSystemItems: state.selectedSteps.productSystemItems.filter(function(value, index, arr){ return value !== action.value;}),
        },
        currentStep: state.currentStep
      };

    case actionTypes.UNSET_WIZARD_COUNTRY:
      return {
        ...state,
        selectedSteps: {
          country: '',
          fwk: '',
          location: '',
          executionType: '',
          mediumTypes: '',
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: 'country'
      };

    case actionTypes.UNSET_WIZARD_FWK:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: '',
          location: '',
          executionType: '',
          mediumTypes: '',
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: 'fwk'
      };

    case actionTypes.UNSET_WIZARD_LOCATION:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: '',
          executionType: '',
          mediumTypes: '',
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: 'location'
      };

    case actionTypes.UNSET_WIZARD_EXECUTION_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: '',
          mediumTypes: '',
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: 'execution_type'
      };

    case actionTypes.UNSET_WIZARD_MEDIUM_TYPE:
      return {
        ...state,
        selectedSteps: {
          country: state.selectedSteps.country,
          fwk: state.selectedSteps.fwk,
          location: state.selectedSteps.location,
          executionType: state.selectedSteps.executionType,
          mediumTypes: '',
          productSystem: '',
          productSystemItems: [],
        },
        currentStep: 'medium_type'
      };


    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/wizard.js